import React from "react";

const TopRatedList = ({ articles }) => {
  return (
    <ol id="#topRated" type="1" className="top-articles">
      <h1> Top 5 High Rating Posts</h1>
      {articles.map((data, idx) => {
        const { title, name, averageRating } = data._id;

        return (
          <li key={idx}>
            <a href={`/article/${name}`}>
              <h2>{title}</h2>
            </a>
            <span>Average of {averageRating} ⭐star rating!</span>
          </li>
        );
      })}
    </ol>
  );
};

export default TopRatedList;
